document.addEventListener('DOMContentLoaded', function (event) {
    if (document.querySelectorAll('.news-list-view.pagination-infinity').length > 0) {
        // for each .news-list-view element, create a new InfiniteScroll instance
        document.querySelectorAll('.news-list-view.pagination-infinity').forEach((elem) => {
            if(elem.querySelector('.f3-widget-paginator')) {
                const infiniteScrollItem = new InfiniteScroll(elem.querySelector('.row'), {
                    history: false,
                    path: '#' + elem.id + '.news-list-view .next a',
                    append: '#' + elem.id + '.news-list-view .paginateItem',
                    // using button, disable loading on scroll
                    scrollThreshold: 100,
                    status: '#' + elem.id + '.news-list-view .page-load-status',
                    hideNav: '#' + elem.id + '.news-list-view .f3-widget-paginator',
                    checkLastPage: '#' + elem.id + '.news-list-view .next a',
                });

                // a11y - set focus on the first element of the new page
                // for accessibility reasons
                infiniteScrollItem.on('load', function(body, path, response) {
                    // set focus on the first element of the new page
                    const lastElement = document.querySelector('#' + elem.id + '.news-list-view .row .paginateItem:last-child a');
                    lastElement?.focus();
                });
            }
        });
    }
});
